import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import ClientUnavailable from "@/pages/client/ClientUnavailable";

export function RequireAuth({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-jigsaw-bg">
        <div className="h-6 w-6 animate-spin rounded-full border-2 border-jigsaw-border border-t-jigsaw-orange" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

export function RequireWorkspace({ type, children }) {
  const { hasWorkspace, memberships, connectEnabled } = useAuth();
  if (!hasWorkspace(type)) return <Navigate to={memberships.length ? "/" : "/login"} replace />;
  if (type === "CLIENT" && !connectEnabled) return <ClientUnavailable />;  // the server enforces the switch; this hides the workspace shell
  return children;
}
